export const imageFallback = process.env.PLACEHOLDER_IMAGE;
